import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { categoryListStyles } from "@insite/content-library/Widgets/Category/CategoryList";

import { css } from "styled-components";

categoryListStyles.categoryImage = mergeToNew(categoryListStyles.categoryImage, {
    width: "100%",
    height: "auto",
});

categoryListStyles.categoryImageItem = mergeToNew(categoryListStyles.categoryImageItem, {
    css: css`
        height: 100%;
    `,
});

categoryListStyles.categoryImageLink = mergeToNew(categoryListStyles.categoryImageLink, {
    typographyProps: {
        css: css`
            width: 100%;
        `,
    },
    css: css`
        width: 100%;
    `,
});

categoryListStyles.categoryName = mergeToNew(categoryListStyles.categoryName, {
    color: "text.accent",
});
